<div class="container" *transloco="let t">
  <div class="title box">
    <app-svg-icon class="icon" [path]="'/assets/' + option().icon"/>
    <p>{{ t(option().displayName) }}</p>
  </div>
  <div class="value box">
    <p>{{ t(option().selectedValue.label) }}</p>
    <app-svg-icon class="icon" [path]="'/assets/arrow_right.svg'"/>
  </div>
</div>
